import { PurchaseOrderLineItem, ProductVariant } from './api';

// Enhanced line item with temporary UUID and status tracking
export interface ManagedLineItem extends PurchaseOrderLineItem {
  tempId: string; // UUID for new items, used for React keys and operations
  status: LineItemStatus;
  originalItem?: PurchaseOrderLineItem; // For restoration after deletion
}

export enum LineItemStatus {
  ACTIVE = 'active',
  PENDING_DELETE = 'pending_delete',
  DELETED = 'deleted'
}

// A variant being added as a line item. Special (SPE) line items have no
// product, so they carry their own description and taxable flag.
export type LineItemVariant = ProductVariant & {
  description?: string;
  taxable?: boolean;
};

// Actions for the line item reducer
export type LineItemAction =
  | { type: 'ADD_ITEM'; payload: { variant: LineItemVariant; quantity: number } }
  | { type: 'REMOVE_ITEM'; payload: { tempId: string } }
  | { type: 'RESTORE_ITEM'; payload: { tempId: string } }
  | { type: 'UPDATE_QUANTITY'; payload: { tempId: string; quantity: number } }
  | { type: 'UPDATE_FIELD'; payload: { tempId: string; field: string; value: any } }
  | { type: 'SET_ITEMS'; payload: { items: PurchaseOrderLineItem[] } }
  | { type: 'MERGE_SERVER_ITEMS'; payload: { items: PurchaseOrderLineItem[] } }
  | { type: 'CLEAR_DELETED' }
  | { type: 'MOVE_ITEM_UP'; payload: { tempId: string } }
  | { type: 'MOVE_ITEM_DOWN'; payload: { tempId: string } };

// Validation result for line item operations
export interface LineItemValidation {
  isValid: boolean;
  errors: string[];
}

// Configuration for line item operations
export interface LineItemConfig {
  allowDuplicates: boolean;
  minQuantity: number;
  validateReceipts: boolean;
}

// Summary data for purchase order calculations
export interface LineItemSummary {
  activeItems: ManagedLineItem[];
  subTotal: number;
  taxAmount: number;
  total: number;
  itemCount: number;
}